import { HealthConditionsScreen } from '@/components/HealthConditionsScreen';

export default function HealthConditions() {
  return <HealthConditionsScreen />;
}
